import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

const StyledSection = styled(Section)`
  ${breakpointsMedia({
    lg: css`
      padding-top: ${({ theme }) => theme.menuHeight.desktopLarge}px;
    `,
  })}
`;

// TODO: delete this styled components once new Typoghraphy variants are implemented
const StyledTypography = styled(Typography)`
  font-size: 1.875rem;
  line-height: 1.2;
  letter-spacing: -0.03em;

  ${breakpointsMedia({
    lg: css`
      font-size: 3rem;
      line-height: 1.16;
   `,
  })}
`;

function OldPageSectionHeading({ children, textAlign, intlKey }) {
  return (
    <StyledSection
      minHeight="auto"
      backgroundColor="primary.default"
    >
      <Block
        blockWidth="100%"
        padding={{ desktop: paddingBuilder.vertical(8) }}
        textAlign={textAlign}
      >
        <StyledTypography
          color="white"
          colorVariant="default"
          intlKey={intlKey}
          variant="title"
        >
          {children}
        </StyledTypography>
      </Block>
    </StyledSection>
  );
}

OldPageSectionHeading.defaultProps = {
  textAlign: 'left',
  children: undefined,
  intlKey: '',
};

OldPageSectionHeading.propTypes = {
  children: PropTypes.node,
  intlKey: PropTypes.string,
  textAlign: PropTypes.string,
};

export default OldPageSectionHeading;
